import { optionNamesMatch } from '@/utils/product/product-context-helpers';

export const BIRCH_COOLING_OPTION_NAME = 'Cooling Options';
export const BIRCH_COLOR_OPTION_NAME = 'Color';
export const BIRCH_SIZE_OPTION_NAME = 'Size';
/** Gallery tag driver priority. Add names here to support non-color variant galleries (e.g. 'Material'). */
export const BIRCH_GALLERY_OPTION_NAMES = [BIRCH_COLOR_OPTION_NAME];

export function resolveVariantSwatchesOptionName(block) {
  return (block?.section_title || block?.heading || '').trim() || BIRCH_COLOR_OPTION_NAME;
}

export function resolveVariantButtonsOptionName(block) {
  return (block?.section_title || '').trim() || BIRCH_COOLING_OPTION_NAME;
}

export function getShopifyOptionByName(shopifyProduct, optionName) {
  const opts = shopifyProduct && shopifyProduct.options;
  if (!opts) return null;
  const found = opts.find((o) => optionNamesMatch(o.name, optionName));
  return found || null;
}

export function getFirstShopifyOptionByName(shopifyProduct, optionNames) {
  if (!optionNames || !optionNames.length) return null;
  for (const optionName of optionNames) {
    const found = getShopifyOptionByName(shopifyProduct, optionName);
    if (found) return found;
  }
  return null;
}
